import { ConfigFieldEntry } from "./../destinations/types";
export type SquareLogoElement = React.ForwardRefExoticComponent<any>;

export type NonConfigurableSource =
  | {
      key: string;
      name: string;
      logoSquare: SquareLogoElement;
      modal:
        | "Web"
        | "Server Side"
        | "React Native"
        | "Android"
        | "iOS"
        | "Sendinblue"
        | "Mailchimp"
        | "SendGrid"
        | "Customer.io"
        | "Kustomer"
        | "Intercom"
        | "CallRail"
        | "Invoca";
    }
  | {
      key: string;
      name: string;
      logoSquare: SquareLogoElement;
      modal: "Contact Us";
      body: string;
    };

export type SourceSlug =
  | "bigquery"
  | "hubspot"
  | "iterable"
  | "postgres"
  | "redshift"
  | "salesforce"
  | "shopify"
  | "snowflake"
  | "stripe";

export type SourceName =
  | "BigQuery"
  | "HubSpot"
  | "Iterable"
  | "Postgres"
  | "Redshift"
  | "Salesforce"
  | "Shopify"
  | "Snowflake"
  | "Stripe";

export type ConfigurableSource = {
  key: string;
  name: string;
  logoSquare: SquareLogoElement;
  modal: "Contact Us";
  body: JSX.Element | string;
  configHelp: JSX.Element | string;
  configBodyHelp: JSX.Element | string;
  configFields: ConfigFieldEntry[];
  slug: SourceSlug;
};

export type Source = NonConfigurableSource | ConfigurableSource;

export type ObjectSource = {
  fivetranService:
    | "adjust"
    | "adobe_analytics"
    // | "adobe_analytics_data_feed"
    | "adp_workforce_now"
    | "adroll"
    | "airtable"
    | "s3"
    | "anaplan"
    | "apache_kafka"
    // | "itunes_connect" # Not supported by connector cards
    | "amplitude"
    | "apple_search_ads"
    | "appsflyer"
    | "asana"
    | "aws_cloudtrail"
    | "aws_inventory"
    | "aws_lambda"
    | "aws_msk"
    | "azure_blob_storage"
    | "azure_function"
    | "azure_event_hub"
    | "braintree"
    | "branch"
    | "braze"
    | "cloudfront"
    | "confluent_cloud"
    | "coupa"
    | "criteo"
    | "delighted"
    | "dropbox"
    | "dynamodb"
    | "eloqua"
    | "email"
    // | "facebook_ad_account" # Fivetran sunset this
    // | "facebook" # Fivetran sunset this
    | "facebook_ads"
    | "facebook_pages"
    | "financial_force"
    // | "fivetran_log"
    | "freshdesk"
    | "front"
    | "ftp"
    | "github"
    | "double_click_publishers"
    | "google_ads_account"
    | "google_analytics"
    | "google_analytics_360"
    | "google_analytics_mcf"
    | "double_click_campaign_manager"
    | "google_cloud_function"
    | "gcs"
    | "google_display_and_video_360"
    | "google_play"
    | "google_search_console"
    | "google_sheets"
    | "greenhouse"
    // | "heap"
    | "height"
    | "helpscout"
    | "heroku_kafka"
    | "hubspot"
    | "instagram_business"
    | "intercom"
    | "iterable"
    | "jira"
    | "kinesis"
    | "klaviyo"
    | "kustomer"
    | "lever"
    | "light_speed_retail"
    | "linkedin_ads"
    | "linkedin_company_pages"
    | "mailchimp"
    | "mandrill"
    | "maria_azure"
    | "maria"
    | "maria_rds"
    | "marin"
    | "marketo"
    | "mavenlink"
    | "bingads"
    | "dynamics_365"
    | "dynamics_365_fo"
    | "mixpanel"
    | "mongo"
    | "mongo_sharded"
    | "aurora"
    | "mysql_azure"
    | "mysql"
    | "google_cloud_mysql"
    | "magento_mysql"
    | "magento_mysql_rds"
    | "mysql_rds"
    | "netsuite_suiteanalytics"
    | "optimizely"
    | "oracle"
    | "oracle_rac"
    | "oracle_rds"
    | "oracle_ebs"
    | "oracle_cloud_apps_customer_experience"
    | "oracle_cloud_apps_erp_scm"
    | "outbrain"
    | "outreach"
    | "pardot"
    | "pendo"
    | "pinterest_ads"
    | "pipedrive"
    | "aurora_postgres"
    | "azure_postgres"
    | "postgres"
    | "google_cloud_postgresql"
    | "heroku_postgres"
    | "postgres_rds"
    | "qualtrics"
    | "quickbooks"
    | "recharge"
    | "recurly"
    | "sage_intacct"
    | "sailthru"
    | "salesforce"
    | "salesforce_marketing_cloud"
    | "sap_concur"
    | "sap_hana"
    | "sap_s4hana"
    | "sendgrid"
    | "servicenow"
    | "sftp"
    | "shopify"
    | "snapchat_ads"
    // | "snowplow"
    | "splunk"
    | "azure_sql_db"
    | "sql_server"
    | "sql_server_rds"
    | "square"
    | "stripe"
    | "survey_monkey"
    | "taboola"
    | "tiktok_ads"
    | "twilio"
    | "twitter"
    | "twitter_ads"
    | "typeform"
    | "uservoice"
    | "yahoo_gemini"
    | "workday"
    | "xero"
    | "youtube_analytics"
    | "zendesk_chat"
    | "zendesk_sunshine"
    | "zendesk"
    | "zoho"
    | "zuora";
  name: string;
  description?: string;
  logo?: SquareLogoElement;
};

export type ObjectSourceCategory = {
  name: string;
  description?: string;
  logo: SquareLogoElement;
  items: ObjectSource[];
};

export function isAObjectSourceCategory(
  choice: ObjectSource | ObjectSourceCategory
): choice is ObjectSourceCategory {
  return choice.hasOwnProperty("items");
}
